import { PlatformLocation } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent,
} from "@angular/router";
import { interval, Subscription } from "rxjs";
import { CtxMenuSezioni } from "./common/models/ctx-menu-sezioni";
import { ObservableManager } from "./common/utils/observable-manager";
import { FrontEndMapping } from "./core/configuration/front-end-mapping";
import { UrlSettingsCore } from "./core/configuration/url-settings-core";
import { FascicoliMappingService } from "./core/services/fascicoli-mapping.service";
import { HelpersService } from "./core/services/helpers.service";
import { PraticheMappingService } from "./core/services/pratiche-mapping.service";
import { UserManager } from "./core/services/user-manager";
import { ViewManagerService } from "./core/services/view-manager-service";
import { AppData } from "./data-store";
import { ResponsiveService } from "./core/services/responsive.service";
import { Breakpoints } from "@angular/cdk/layout";
import { ConfigurationFeature } from "./common/configuration/models/configuration";
import { ConfigurationData } from "./common/configuration/stores/data-configuration-store";
import { ConfigurationService } from "./common/configuration/services/configuration.service";
import { pdaConfiguration } from "./pda/utils/pda-configuration";
import { NomiDescrittoriSezione } from "./common/configuration/nomi-descrittori-sezione";
import { PdaPlaceholders } from "./pda/utils/placeholder";
import { OauthService } from "./oauth.service";
import { PdaConfigurationService } from "./pda/utils/Service/pda-config.service";
import { environment } from "src/environments/environment";
import { SsoStrategyService } from "./sso-strategy.service";
import { Title } from "@angular/platform-browser";
import { PdaAcceptanceInfos, PdaAuthService } from "./pda/utils/Service/pda-auth.service";

@Component({
  selector: 'my-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [UserManager]
})
export class AppComponent implements OnInit {

  loading: boolean = true;
  show: boolean = false;
  isLogin: boolean = null;
  isRouteScAnaliticaSintetica = false;
  isLogged: boolean = false;
  isOauthLogged = false;
  subscriptionUserLogged: Subscription;
  subscriptionctxMenuSezioni: Subscription;
  menuSezioni: CtxMenuSezioni;
  isTabletSizeScreen = false;
  refreshTokenSub: Subscription;
  refreshPdaTokenTimer: Subscription;
  refreshTokenTimer: Subscription;
  tokenObtained: Subscription;
  authMode: string = null;
  forbidden = false;
  currentTitle: string = "";
  private configLoaded = false;

  @ViewChild('content') content: ElementRef;
  @HostListener('document:click', ['$event'])
  clickOutSidebarMenu(event) {
    if(this.content?.nativeElement.contains(event.target)) {
      this.responsive.closeSidebar();
    }
  }

  constructor(
      private responsive: ResponsiveService,
      private router: Router,
      private observableManager: ObservableManager,
      private helpers: HelpersService,
      private userManager: UserManager,  
      private viewManagerService: ViewManagerService,
      location: PlatformLocation,
      private frontEndMapping: FrontEndMapping,
      private fascicoliMappingService: FascicoliMappingService,
      private praticheMappingService: PraticheMappingService,
      private cd: ChangeDetectorRef,
      private config: ConfigurationService,
      private configData: ConfigurationData,
      private oauthService: OauthService,
      private pdaConfigurationService: PdaConfigurationService,
      private activatedRoute: ActivatedRoute,
      private ssoStrategy: SsoStrategyService,
      private authPda: PdaAuthService,
      private titleService: Title
    ) {
    this.loading = true;
    location.onPopState(() => {
      console.log('pressed back!');
    });

    // Fix #3: il ramo isLogged è riservato a ldap.
    // In oauth2 l'inizializzazione avviene solo in onTokenObtained(),
    // evitando doppie chiamate a getUser/getRolesByUserData/loadConfigurations.
    // Il ramo !isLogged (logout/reset stato) rimane attivo per entrambe le modalità.
    this.subscriptionUserLogged = this.userManager.getUserLogged().subscribe(isLogged => {
      if (isLogged && this.authMode !== 'oauth2') {
        this.userManager.getUser();
        this.helpers.getRolesByUserData().subscribe(
          () => {
            this.loadConfigurations();
          }
        );
        this.userManager.afterToken().subscribe((res) => {
          if (res) {
            this.praticheMappingService.getAllTipiPratica().subscribe((res) => res);
            this.fascicoliMappingService.getAllTipiFascicolo().subscribe((res) => res);
            this.show = true;
          }
        });
        this.isLogged = isLogged;
      } else if (!isLogged) {
        this.show = false;
        this.configLoaded = false;
        if(this.refreshPdaTokenTimer) {
          this.refreshPdaTokenTimer.unsubscribe();
        }
      }
    });

    this.subscriptionctxMenuSezioni = this.viewManagerService.ctxMenuSezioni.subscribe(res => {
      this.menuSezioni = res;
    });

    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  private configurePda() {
    let indexRol = AppData.getInstance().userRoles.findIndex(x => x.nomeRuolo === "PROCESSO TELEMATICO");
    if(this.config.isFeatureEnabled(ConfigurationFeature.JUSTICE_PDA)) {
      this.pdaConfigurationService.getConfigurationProperties().subscribe(() => console.log("pda config initiated"));
    }
    if (indexRol > -1 && this.config.isFeatureEnabled(ConfigurationFeature.JUSTICE_PDA)) {
      localStorage.setItem(PdaPlaceholders.pda_rol, "true");
      pdaConfiguration.forEach(x => {
        if(x.context === "USER" || x.context === NomiDescrittoriSezione.DESCRITTORE_CANCELLERIA_TELEMATICA) {
          x.enabled = true;
        }
      });
    } else {
      pdaConfiguration.forEach(x => x.enabled = false);
    }
  }

  private loadConfigurations() {
    if (this.configLoaded) {
      return;
    }
    this.configLoaded = true;
    this.checkPersistentConnectionToPda();

    if (!AppData.getInstance().configurations) {
      this.config.getConfigurations().subscribe({
        next: (configurations) => {
          localStorage.setItem("configurations", JSON.stringify(configurations));
          AppData.getInstance().configurations = configurations;
          this.config.configurationLoaded(true);
          this.configurePda();
        }
      });
    } else {
      this.configurePda();
    }
  }

  ngOnInit() {
    console.log('on init');
    this.authPda.isLogged.subscribe(
      async (isLogged) => {
        if(isLogged === true) {
          let pdaAcceptanceInfos = await this.authPda.getPdaInfos();
          if(pdaAcceptanceInfos && pdaAcceptanceInfos.acceptanceFlag){
            this.refreshPdaTokenPeriodically();
          } else {
            this.checkTemporaryTokenValidity();
          }
        } else {
          if(this.refreshPdaTokenTimer) {
            this.refreshPdaTokenTimer.unsubscribe();
          }
        }
      }
    );
    this.authMode = this.ssoStrategy.getAuthMode();

    // Fix #7: al logout resetta tutto lo stato del componente in modo centralizzato
    this.oauthService.onLogout.subscribe(() => {
      if(this.refreshPdaTokenTimer) {
        this.refreshPdaTokenTimer.unsubscribe();
      }
      this.unsubscribeAllEvents();
      this.isOauthLogged = false;
      this.show = false;
      this.configLoaded = false;
      this.ssoStrategy.onForbidden(false);
    });

    this.ssoStrategy.forbidden.subscribe(param => {
      this.forbidden = param;
    });
    this.onTokenObtained();
    window.addEventListener("storage", (ev) => {
      if(ev.key === "configurations" && !ev.newValue) {
        // ev.newValue = ev.oldValue;
      }
    });
    this.isRouteScAnaliticaSintetica = window.location.href.includes("scheda_analitica") || window.location.href.includes("scheda_sintetica");
    this.responsive.checkScreenSizeDynamic([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium
    ]).subscribe(
      state => this.isTabletSizeScreen = state.matches
    );
  }

  private onTokenObtained() {
    this.tokenObtained = this.oauthService.tokenObtained.pipe().subscribe(
      hasToken => {
        if (hasToken) {
          this.userManager.getUser();
          this.helpers.getRolesByUserData().subscribe(
            () => {
              this.loadConfigurations();
            }
          );
          this.userManager.afterToken().subscribe((res) => {
            if (res) {
              this.praticheMappingService.getAllTipiPratica().subscribe((res) => res);
              this.fascicoliMappingService.getAllTipiFascicolo().subscribe((res) => res);
              this.show = true;
            }
          });
          this.isLogged = hasToken;
          this.isOauthLogged = hasToken;
          console.log(hasToken, 'token obtained');
          const expiresIn = Number(localStorage.getItem("expires_in"));
          const timeMs = (expiresIn * 1000) - 20000;
          // let timeMs = 5000; /** PER TEST */
          this.refreshTokenTimer = interval(timeMs).subscribe(() => {
            this.refreshAccessToken();
          });
        }
      }
    );
  }

  private unsubscribeAllEvents() {
    if (this.tokenObtained) {
      this.tokenObtained.unsubscribe();
    }
    if (this.refreshTokenSub) {
      this.refreshTokenSub.unsubscribe();
    }
    if (this.refreshTokenTimer) {
      this.refreshTokenTimer.unsubscribe();
    }
  }

  private refreshAccessToken() {
    this.oauthService.refreshAccessToken().subscribe({
      next: res => {
        console.log("refresh token");
        localStorage.setItem("access_token", res.access_token);
        localStorage.setItem("refresh_token", res.refresh_token);
        localStorage.setItem("expires_in", res.expires_in.toString());
        localStorage.setItem("refresh_expires_in", res.refresh_expires_in.toString());
        localStorage.setItem("session_state", res.session_state);
        localStorage.setItem("id_token", res.id_token);
        this.isOauthLogged = true;
        this.ssoStrategy.onForbidden(false);
      },
      error: err => {
        if (this.refreshTokenTimer) { this.refreshTokenTimer.unsubscribe(); }
        this.isOauthLogged = false;
        this.ssoStrategy.onForbidden(true);
        this.router.navigate([UrlSettingsCore.URL_FORBIDDEN]);
      }
    });
  }

  logoutOAuth() {
    this.oauthService.invalidateTokenSession();
  }

  ngAfterViewChecked() {
    this.cd.detectChanges();
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
    }
    if (event instanceof NavigationEnd) {
      this.setTitelPage();
      this.loading = false;
      this.checkLoggedUser(
        event,
        event.url === '/' || 
        event.url === '/' + UrlSettingsCore.URL_LOGIN
      );
    }
    if (event instanceof NavigationCancel) {
      this.loading = false;
    }
    if (event instanceof NavigationError) {
      this.loading = false;
    }
  }

  private checkLoggedUser(event, isLogin) {
    this.isLogin = event.url === '/' + UrlSettingsCore.URL_LOGIN;
    if (this.userManager.isLogged()) {
      this.userManager.sendUserLogged(true);
    } else {
      this.userManager.sendUserLogged(false);
      if (!isLogin) {
        this.userManager.getUser();
      }
    }
  }

  setTitelPage() {
    let child = this.activatedRoute.firstChild;
    let title = child.snapshot.data['title'];
    while(child.firstChild){
      child = child.firstChild;
    }
    if(title != child.snapshot.data['title']) {
      title = title + ' - ' + child.snapshot.data['title'];
    }
    this.currentTitle = title;
    this.titleService.setTitle('Teleforum | ' + title);
  }

  // Fix #5: null-check su refreshPdaTokenTimer prima di unsubscribe
  ngOnDestroy() {
    this.unsubscribeAllEvents();
    if (this.refreshPdaTokenTimer) {
      this.refreshPdaTokenTimer.unsubscribe();
    }
  }

  async checkPersistentConnectionToPda() {
    console.log('checkPersistentConnectionToPda');
    let token = await this.authPda.getPdaToken();

    if(token){
      let pdaAcceptanceInfos = await this.authPda.getPdaInfos();
      if(pdaAcceptanceInfos && pdaAcceptanceInfos.acceptanceFlag){
        console.log("pda connection is persistent. fetching user token.");
        this.getPdaToken();
      } else {
        console.log("pda connection is not persistent.");
        this.authPda.setIsLogged(true);
      }
    } else {
      this.getPdaToken();
    }
  }

  getPdaToken(){
    this.authPda.getUserToken().subscribe({
      next: async (token) => {
        await this.authPda.setPdaToken(token);
        let pdaInfos: PdaAcceptanceInfos = {acceptanceFlag: true, acceptanceTimestamp: Date.now()};
        await this.authPda.setPdaInfos(pdaInfos);
        this.refreshPdaTokenPeriodically();
        this.authPda.setIsLogged(true);
      }
    });
  }

  private refreshPdaTokenPeriodically() {
    if(this.refreshPdaTokenTimer) {
      this.refreshPdaTokenTimer.unsubscribe();
    }
    const timeMs = 300 * 1000;
    this.refreshPdaTokenTimer = interval(timeMs).subscribe(() => {
      this.authPda.getUserToken().subscribe(
        async (refreshedToken) => {
          await this.authPda.setPdaToken(refreshedToken);
        }
      );
    });
  }

  private async checkTemporaryTokenValidity() {
    console.log("temporary pda login detected, check temp token validity.");
    let token = await this.authPda.getPdaToken();
    if(!!token){
      console.log("user is logged to pda: ", token);
      let pdaAcceptanceInfos = await this.authPda.getPdaInfos();
      if(!!pdaAcceptanceInfos){
        if(!pdaAcceptanceInfos.acceptanceFlag){
          console.log("login is temporary.");
          let timeMargin = 5 * 60 * 1000;
          let timeElapsed = pdaAcceptanceInfos.acceptanceTimestamp + (token.expiresIn*1000) - timeMargin;
          let currentTimestamp = Date.now();
          if(currentTimestamp > timeElapsed){
            this.cleanupPda("Token time has elapsed. Logging out...");
          } else {
            console.log("Token is still valid. Keeping login.");
          }
        }
      } else {
        this.cleanupPda("No acceptance infos found, cannot determine token validity. Logging out...");
      }
    } else {
      this.cleanupPda("user is not logged to pda.");
    }
  }

  private cleanupPda(message: string) {
    console.log(message);
    this.authPda.setIsLogged(false);
    this.removePdaData();
  }

  private async removePdaData() {
    console.log("removing pda data");
    await this.authPda.removePdaToken();
    await this.authPda.removePdaInfos();
    if(this.refreshPdaTokenTimer) {
      this.refreshPdaTokenTimer.unsubscribe();
    }
  }

}